import { GlobalToken } from 'antd';
import styled from 'styled-components';

import { CustomThemeToken } from '@/theme';

interface DrawerContentContainerProps {
  $inMaintenance?: boolean;
  $isMobile?: boolean;
  theme: {
    token: CustomThemeToken;
  };
}

export const DrawerContentContainer = styled.div<DrawerContentContainerProps>`
  height: 100%;
  overflow-x: hidden;
  ${({ $inMaintenance, theme: { token }, $isMobile }) =>
    $inMaintenance
      ? `border-left: 1px solid ${token.Ecoplant_Compressor.colorBGMaintenance};`
      : `padding-top: ${$isMobile ? 0 : token.paddingXL}px;`}

  .maintenance-banner {
    height: 28px;
    width: 100%;
    background-color: ${({ theme: { token } }) => token.Ecoplant_Compressor.colorBGMaintenance};
    padding-left: ${({ theme: { token } }) => token.paddingXS}px;
    display: flex;
    align-items: center;
    color: ${({ theme: { token } }) => token.colorWarningTextHover};
    margin-bottom: ${({ theme: { token } }) => token.marginXXS}px;
  }

  .drawer-details-header {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    .drawer-details-header-buttons {
      display: flex;
      align-items: center;
      gap: ${({ theme: { token } }) => token.marginXS}px;
      margin-right: ${({ theme: { token } }) => token.margin}px;
    }
  }
`;

export const Container = styled.div<{ theme: { token: GlobalToken }; $isMobile: boolean; $fromSCC?: boolean }>`
  display: flex;
  flex-direction: column;
  position: relative;
  ${({ $fromSCC, theme: { token } }) =>
    $fromSCC &&
    `
      padding-bottom: ${token.paddingXL * 2}px;
    `}

  .first-row {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 50px;
    gap: 20px;
    width: 85%;

    .remote-control {
      display: flex;
      align-items: center;
      gap: 4px;

      .remote-control-text {
        color: ${({ theme: { token } }) => token.colorText};
      }
    }
  }

  .second-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: ${({ theme: { token } }) => token.margin}px;
    padding: ${({ theme: { token } }) => token.paddingXS}px ${({ theme: { token } }) => token.padding}px;

    .left {
      display: flex;
      align-items: center;
      gap: 16px;

      .device-icon-and-type {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        gap: ${({ theme: { token } }) => token.marginXXS}px;

        .device-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          width: 32px;
          height: 32px;

          svg {
            width: 100%;
            height: 100%;
          }
        }
      }

      .device-info {
        display: flex;
        flex-direction: column;
        gap: ${({ theme: { token } }) => token.marginXS}px;
      }

      .device-name {
        font-size: ${({ theme: { token } }) => token.fontSizeHeading3}px;
      }

      .device-model {
        font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
        color: ${({ theme: { token } }) => token.colorTextDescription};
      }
    }

    .right {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      gap: ${({ theme: { token } }) => token.margin}px;

      .connectivity-icon-wrapper {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
      }

      .activity-icon-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        gap: ${({ theme: { token } }) => token.margin}px;

        > *:first-child {
          margin-top: 0;
        }
      }

      .activity-label {
        color: ${({ theme: { token } }) => token.colorTextDescription};
      }
    }
  }

  ${({ $isMobile, theme: { token } }) =>
    $isMobile &&
    `
      .drawer-details-header {
        position: sticky;
        top: 0;
        z-index: 1;
        background-color: ${token.colorBgElevated};
      }

    .first-row {
      justify-content: flex-start;
      width: 100%;
      padding: 0 ${token.padding}px;
    }

    .second-row {
      align-items: flex-start;
      .left {
        flex-direction: column;
        align-items: flex-start;
      }

      .right {
        flex-direction: row;
      }
    }
  `}
`;
